/* import __COLOCATED_TEMPLATE__ from './mark-project-active-feedback.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { closeModal } from 'sh-www/utils/modal-controls';
import { task } from 'ember-concurrency';
import { handleFormErrorOrModal, clearErrors } from 'sh-www/utils/handles-errors';

const CLASS_NAME = 'SH-c-mark-project-active-feedback';

const FORM_INPUTS = [
  'feedback_reason',
  'feedback_text'
]

class MarkProjectActiveFeedback extends Component {
  @tracked reason = '';
  @tracked otherText = '';
  @tracked errors = {};

  get baseClassName() {
    return CLASS_NAME;
  }

  @action
  onReasonSelected(reason) {
    clearErrors(this);
    this.reason = this.reason === reason ? '' : reason
    this.otherText = '';
  }

  @action
  onOtherTextInput(value) {
    this.otherText = value;
  }

  @action
  handleClose() {
    closeModal(this);
  }

  @task
  *handleSubmitTask() {
    clearErrors(this);
    const feedback = { reason: this.reason, otherText: this.otherText };
    const { application } = this.args.model;

    try {
      yield this.args.model.submitAction(application, feedback);
      closeModal(this);
    } catch(error) {
      handleFormErrorOrModal(this, error, FORM_INPUTS, false);
    }
  }
}

export default MarkProjectActiveFeedback;
